var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"graph-container"},[_c('header',[_vm._t("title")],2),_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('div',{ref:"graph",staticClass:"graph w-100"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }